import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { createNlsMiddleware, documentapi } from '@holmescorp/lcc-state';
import { Breadcrumbs } from './index';
import css from '../css/glossary-view.m.css';
const factory = create({
    nls: createNlsMiddleware('quiz'),
    theme,
    documentapi
});
export const GlossaryView = factory(({ id, middleware: { theme, documentapi, nls } }) => {
    const { messages: { glossary_page_title = 'Glossary' } } = nls();
    const themeCss = theme.classes(css);
    documentapi.setTitle(glossary_page_title);
    return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
        w(Breadcrumbs, {}),
        v('div', { classes: [themeCss.content] }, [w('Glossary', { loadall: true })])
    ]);
});
export default GlossaryView;
